import React, { useState } from 'react';
import { Row, Col, Card, CardBody, Input, Button, Label, Table, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import api, { FILE_BASE_URL } from '../../utils/api';
const AdvancedFilter = () => {
    const [filters, setFilters] = useState({
        type: '',
        country: 'فلسطين',
        province: '',
        name: ''
    });
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);

    const countries = [
        'فلسطين', 'الأردن', 'لبنان', 'سوريا', 'مصر', 'السعودية', 'الإمارات', 'قطر', 'الكويت', 'العراق', 'المغرب', 'الجزائر', 'تونس', 'ليبيا', 'السودان', 'اليمن', 'عمان', 'البحرين', 'أخرى'
    ];

    const provinces = [
        'اريحا', 'الخليل', 'القدس', 'بيت لحم', 'جنين', 
        'رام الله', 'سلفيت', 'طوباس', 'طولكرم', 'غزة', 
        'قلقيلية', 'نابلس'
    ];

    const handleInputChange = (field, value) => {
        // إذا تم تغيير الدولة وليست فلسطين، امحي المحافظة
        if (field === 'country' && value !== 'فلسطين') {
            setFilters(prev => ({
                ...prev,
                [field]: value,
                province: ''
            }));
        } else {
            setFilters(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const getAvatarCircle = (name, type) => {
        const firstLetter = name ? name.charAt(0).toUpperCase() : '؟';
        
        const colors = {
            'مؤسسة': '#556ee6',
            'صحفي': '#34c38f',
            'ناشط': '#f46a6a'
        };

        const bgColor = colors[type] || '#74788d';

        return (
            <div 
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: bgColor,
                    color: '#ffffff',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
            >
                {firstLetter}
            </div>
        );
    };

    const getRoutePrefix = (type) => {
        switch(type) {
            case 'صحفي': return '/dashboard/journalists';
            case 'ناشط': return '/dashboard/activists';
            case 'مؤسسة': return '/dashboard/institutions';
            default: return '#';
        }
    };

    const searchData = async () => {
        if (!filters.type && !filters.country && !filters.province && !filters.name.trim()) {
            alert('يرجى تحديد معايير البحث');
            return;
        }

        setLoading(true);
        setHasSearched(true);
        
        try {
            let allResults = [];

            // تحديد APIs للبحث فيها
           const apisToSearch = [];
           if (!filters.type || filters.type === 'صحفي') {
               apisToSearch.push({ url: "/journalists", type: 'صحفي', typeClass: 'success' });
           }
           if (!filters.type || filters.type === 'ناشط') {
               apisToSearch.push({ url: "/activists", type: 'ناشط', typeClass: 'danger' });
           }
           if (!filters.type || filters.type === 'مؤسسة') {
               apisToSearch.push({ url: "/institutions", type: 'مؤسسة', typeClass: 'primary' });
           }

            // جلب البيانات من APIs المحددة
            const responses = await Promise.all(
                apisToSearch.map(cfg => api.get(cfg.url))
            );

            responses.forEach((response, index) => {
                const apiInfo = apisToSearch[index];
                const data = response.data.data || response.data || [];
                
                data.forEach(item => {
                    let formattedItem = {
                        ...item,
                        type: apiInfo.type,
                        typeClass: apiInfo.typeClass
                    };

                    // للمؤسسات: استخدم title بدلاً من full_name
                    if (apiInfo.type === 'مؤسسة') {
                        formattedItem.full_name = item.title;
                        formattedItem.profile_image = item.logo;
                    }

                    allResults.push(formattedItem);
                });
            });

            // تطبيق الفلاتر
            let filteredResults = allResults;

            // فلتر حسب الفئة
            if (filters.type) {
                filteredResults = filteredResults.filter(item => item.type === filters.type);
            }

            // فلتر حسب الدولة
            if (filters.country) {
                filteredResults = filteredResults.filter(item => 
                    item.country === filters.country
                );
            }

            // فلتر حسب المحافظة
            if (filters.province) {
                filteredResults = filteredResults.filter(item => 
                    item.country_province === filters.province
                );
            }

            // فلتر حسب الاسم
            if (filters.name.trim()) {
                const searchName = filters.name.trim().toLowerCase();
                filteredResults = filteredResults.filter(item => 
                    item.full_name && item.full_name.toLowerCase().includes(searchName)
                );
            }

            setResults(filteredResults);
        } catch (error) {
            console.error("خطأ في البحث:", error);
            alert("حدث خطأ أثناء البحث");
        } finally {
            setLoading(false);
        }
    };

    const clearFilters = () => {
        setFilters({ type: '', country: 'فلسطين', province: '', name: '' });
        setResults([]);
        setHasSearched(false);
    };

    return (
        <Card className="border-0 shadow-lg">
            <CardBody>
                {/* Header */}
                <div className="d-flex align-items-center mb-4">
                    <div 
                        className="d-flex align-items-center justify-content-center rounded-circle me-3"
                        style={{
                            width: '50px',
                            height: '50px',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white'
                        }}
                    >
                        <i className="mdi mdi-magnify mdi-24px"></i>
                    </div>
                    <div>
                        <h4 className="card-title mb-1">البحث المتقدم</h4>
                        <p className="text-muted mb-0">ابحث في قاعدة البيانات باستخدام معايير متقدمة</p>
                    </div>
                </div>
                
                {/* Search Form */}
                <div 
                    className="p-4 rounded"
                    style={{ 
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                        border: '1px solid #e3ebf0'
                    }}
                >
                    <Row className="g-3 align-items-end">
                        <Col lg="2" md="6">
                            <div className="position-relative">
                                <Label className="form-label fw-semibold text-dark">
                                    <i className="mdi mdi-shape me-2 text-primary"></i>
                                    الفئة
                                </Label>
                                <Input
                                    type="select"
                                    value={filters.type}
                                    onChange={(e) => handleInputChange('type', e.target.value)}
                                    className="form-control-lg border-0 shadow-sm"
                                    style={{ 
                                        borderRadius: '12px',
                                        paddingRight: '3rem' // مساحة للسهم
                                    }}
                                >
                                    <option value="">جميع الفئات</option>
                                    <option value="صحفي">صحفي</option>
                                    <option value="ناشط">ناشط</option>
                                    <option value="مؤسسة">مؤسسة</option>
                                </Input>
                            </div>
                        </Col>
                        
                        <Col lg="2" md="6">
                            <div className="position-relative">
                                <Label className="form-label fw-semibold text-dark">
                                    <i className="mdi mdi-earth me-2 text-info"></i>
                                    الدولة
                                </Label>
                                <Input
                                    type="select"
                                    value={filters.country}
                                    onChange={(e) => handleInputChange('country', e.target.value)}
                                    className="form-control-lg border-0 shadow-sm"
                                    style={{ 
                                        borderRadius: '12px',
                                        paddingRight: '3rem' // مساحة للسهم
                                    }}
                                >
                                    <option value="">جميع الدول</option>
                                    {countries.map(country => (
                                        <option key={country} value={country}>{country}</option>
                                    ))}
                                </Input>
                            </div>
                        </Col>

                        {/* المحافظة - تظهر فقط إذا كانت الدولة فلسطين */}
                        {filters.country === 'فلسطين' && (
                            <Col lg="3" md="6">
                                <div className="position-relative">
                                    <Label className="form-label fw-semibold text-dark">
                                        <i className="mdi mdi-map-marker me-2 text-success"></i>
                                        المحافظة
                                    </Label>
                                    <Input
                                        type="select"
                                        value={filters.province}
                                        onChange={(e) => handleInputChange('province', e.target.value)}
                                        className="form-control-lg border-0 shadow-sm"
                                        style={{ 
                                            borderRadius: '12px',
                                            paddingRight: '3rem' // مساحة للسهم
                                        }}
                                    >
                                        <option value="">جميع المحافظات</option>
                                        {provinces.map(province => (
                                            <option key={province} value={province}>🏛️ {province}</option>
                                        ))}
                                    </Input>
                                </div>
                            </Col>
                        )}
                        
                        <Col lg={filters.country === 'فلسطين' ? 3 : 4} md="8">
                            <div className="position-relative">
                                <Label className="form-label fw-semibold text-dark">
                                    <i className="mdi mdi-account-search me-2 text-warning"></i>
                                    الاسم
                                </Label>
                                <Input
                                    type="text"
                                    placeholder="🔍 ابحث بالاسم..."
                                    value={filters.name}
                                    onChange={(e) => handleInputChange('name', e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && searchData()}
                                    className="form-control-lg border-0 shadow-sm"
                                    style={{ borderRadius: '12px' }}
                                />
                            </div>
                        </Col>
                        
                        <Col lg={filters.country === 'فلسطين' ? 2 : 3} md="4">
                            <Label className="form-label">&nbsp;</Label>
                            <div className="d-flex gap-2">
                                <Button 
                                    color="primary" 
                                    onClick={searchData}
                                    disabled={loading}
                                    className="btn-lg flex-grow-1 shadow-sm"
                                    style={{ 
                                        borderRadius: '12px',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        border: 'none'
                                    }}
                                >
                                    {loading ? (
                                        <>
                                            <div className="spinner-border spinner-border-sm me-2"></div>
                                            بحث
                                        </>
                                    ) : (
                                        <>
                                            <i className="mdi mdi-magnify me-2"></i>
                                            بحث
                                        </>
                                    )}
                                </Button>
                                <Button 
                                    color="light" 
                                    onClick={clearFilters}
                                    disabled={loading}
                                    className="btn-lg shadow-sm"
                                    style={{ borderRadius: '12px' }}
                                    title="مسح الفلاتر"
                                >
                                    <i className="mdi mdi-refresh text-primary"></i>
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* Results Section */}
                {hasSearched && (
                    <div className="mt-5">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center">
                                <div 
                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                                        color: 'white'
                                    }}
                                >
                                    <i className="mdi mdi-format-list-bulleted"></i>
                                </div>
                                <div>
                                    <h5 className="mb-0">نتائج البحث</h5>
                                    <small className="text-muted">النتائج المطابقة لمعايير البحث</small>
                                </div>
                            </div>
                            <Badge 
                                color="info" 
                                className="badge-lg px-3 py-2"
                                style={{ 
                                    borderRadius: '20px',
                                    fontSize: '14px',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                }}
                            >
                                <i className="mdi mdi-chart-box me-1"></i>
                                {results.length} نتيجة
                            </Badge>
                        </div>
                        
                        {results.length > 0 ? (
                            <div className="table-responsive">
                                <Table className="table table-borderless table-hover mb-0">
                                    <thead>
                                        <tr style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                                            <th className="border-0 py-3 text-center" style={{ borderRadius: '12px 0 0 12px' }}>
                                                <i className="mdi mdi-image text-primary me-1"></i>
                                                الصورة
                                            </th>
                                            <th className="border-0 py-3">
                                                <i className="mdi mdi-account text-success me-1"></i>
                                                الاسم
                                            </th>
                                            <th className="border-0 py-3 text-center">
                                                <i className="mdi mdi-shape text-warning me-1"></i>
                                                الفئة
                                            </th>
                                            <th className="border-0 py-3 text-center">
                                                <i className="mdi mdi-map-marker text-info me-1"></i>
                                                المحافظة
                                            </th>
                                            <th className="border-0 py-3 text-center">
                                                <i className="mdi mdi-city text-secondary me-1"></i>
                                                المدينة
                                            </th>
                                            <th className="border-0 py-3 text-center" style={{ borderRadius: '0 12px 12px 0' }}>
                                                <i className="mdi mdi-cog text-dark me-1"></i>
                                                الإجراءات
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {results.map((item, index) => (
                                            <tr 
                                                key={`${item.type}-${item.id}-${index}`}
                                                className="border-bottom"
                                                style={{ 
                                                    borderBottom: '1px solid #f1f3f4 !important',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                <td className="text-center py-3">
                                                    {getAvatarCircle(item.full_name, item.type)}
                                                </td>
                                                <td className="py-3">
                                                    <div>
                                                        <h6 className="mb-1 fw-semibold">{item.full_name || 'غير محدد'}</h6>
                                                        {item.specialization && (
                                                            <p className="text-muted mb-0 small">
                                                                <i className="mdi mdi-school me-1"></i>
                                                                {item.specialization}
                                                            </p>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="text-center py-3">
                                                    <Badge 
                                                        color={item.typeClass}
                                                        className="px-3 py-2"
                                                        style={{ borderRadius: '20px', fontSize: '12px' }}
                                                    >
                                                        {item.type}
                                                    </Badge>
                                                </td>
                                                <td className="text-center py-3">
                                                    <span className="text-muted fw-medium">
                                                        {item.country_province || 'غير محدد'}
                                                    </span>
                                                </td>
                                                <td className="text-center py-3">
                                                    <span className="text-muted">
                                                        {item.city_or_area || 'غير محدد'}
                                                    </span>
                                                </td>
                                                <td className="text-center py-3">
                                                    <div className="d-flex gap-2 justify-content-center">
                                                        <Link
                                                            to={`${getRoutePrefix(item.type)}/view/${item.id}`}
                                                            className="btn btn-outline-info btn-sm rounded-circle"
                                                            title="عرض"
                                                            style={{ width: '35px', height: '35px' }}
                                                        >
                                                            <i className="mdi mdi-eye"></i>
                                                        </Link>
                                                        <Link
                                                            to={`${getRoutePrefix(item.type)}/edit/${item.id}`}
                                                            className="btn btn-outline-warning btn-sm rounded-circle"
                                                            title="تحرير"
                                                            style={{ width: '35px', height: '35px' }}
                                                        >
                                                            <i className="mdi mdi-pencil"></i>
                                                        </Link>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <div 
                                className="text-center py-5 rounded"
                                style={{ background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)' }}
                            >
                                <div 
                                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                    style={{
                                        width: '80px',
                                        height: '80px',
                                        background: 'rgba(255,255,255,0.3)',
                                        color: '#8B4513'
                                    }}
                                >
                                    <i className="mdi mdi-magnify mdi-36px"></i>
                                </div>
                                <h5 className="text-dark mb-2">لا توجد نتائج!</h5>
                                <p className="text-muted">لا توجد نتائج تطابق معايير البحث المحددة</p>
                                <Button 
                                    color="primary" 
                                    outline 
                                    onClick={clearFilters}
                                    className="rounded-pill px-4"
                                >
                                    <i className="mdi mdi-refresh me-2"></i>
                                    إعادة تعيين البحث
                                </Button>
                            </div>
                        )}
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default AdvancedFilter;